import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Row, Col, Tab, Nav, Badge, Dropdown } from "react-bootstrap";

import imcoming_call from '../../../../images/manage_calls/incoming_call.ico';
import outgoing_call from '../../../../images/manage_calls/outgoing_call.ico';
import dialed_call from '../../../../images/manage_calls/dialed_call.ico';
import missed_call from '../../../../images/manage_calls/missed_call.ico';
import rejected_call from '../../../../images/manage_calls/reject_call.ico';

import Add from '../../../modal/Lead_Management/Manage_Call/AddLead';
import Location from '../../../modal/Lead_Management/Manage_Call/Location';

import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import DatePicker, { DateObject } from "react-multi-date-picker";
import axios from 'axios';
import LoadingComponent from '../../../layouts/nav/loading';

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Manage_Calls = () => {


    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,

        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list: 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,

    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [yeardisplay, setyeardisp] = useState(new Date());

    const [datas, setData] = useState([]);
    const [responses, setresp] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [loading, setLoading] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    const [incommingCalls, setIncommingCalls] = useState(0);
    const [Outgoingcalls, setOutgoingCalls] = useState(0);
    const [DailedCalls, setDailedCalls] = useState(0);
    const [missedCalls, setMissedCalls] = useState(0);
    const [rejectedCalls, setRejectedCalls] = useState(0);

    const [outgoingCallRate, setOutgoingRate] = useState(0.00);
    const [missedCallRate, setmissedRate] = useState(0.00);

    // page table data fetch
    const fetchData = () => {
        setLoading(true);
        const params = {
            month: yeardisplay.getMonth() + 1,
            year: yeardisplay.getFullYear(),
            page,
            per_page: perPage,
            search: searchTerm,
            branch_id: branch_id
        };
        axios.get(`${baseURL}/get_all_calls/sales`, { params: params })
            .then(response => {
                setData(response.data.data);
                setresp(response.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);

                setIncommingCalls(response.data.incoming);
                setOutgoingCalls(response.data.outgoing);
                setDailedCalls(response.data.dialed);
                setMissedCalls(response.data.missed);
                setRejectedCalls(response.data.rejected);

                setOutgoingRate(response.data.outgoing_call_rate);
                setmissedRate(response.data.missed_call_ratio);
                setLoading(false);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
                setLoading(false);
            });
    };

    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage, yeardisplay]);


    useEffect(() => {
        const tables = document.querySelectorAll('.trip_sheet_table');
        tables.forEach((table) => {
            if (!$.fn.dataTable.isDataTable(table)) {
                $(table).DataTable({
                    "responsive": true,
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        });
    }, []);

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function convert24to12(time24) {
        if (time24) {
            const [hourStr, minute, second] = time24.split(':');
            let hour = parseInt(hourStr, 10);

            const ampm = hour >= 12 ? 'PM' : 'AM';
            hour = hour % 12;
            if (hour === 0) hour = 12;

            // Pad minute and second if needed
            const paddedMinute = minute.padStart(2, '0');
            const paddedSecond = second.padStart(2, '0');

            return `${hour}:${paddedMinute}:${paddedSecond} ${ampm}`;
        } else {
            return '';
        }
    }

    const renderCallStatusContent = (status) => {
        switch (status) {
            case 0:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={outgoing_call} className="border rounded px-1 py-0">
                            <img src={outgoing_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            case 1:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={imcoming_call} className="border rounded px-1 py-0">
                            <img src={imcoming_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            case 2:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={missed_call} className="border rounded px-1 py-0">
                            <img src={missed_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            case 3:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={rejected_call} className="border rounded px-1 py-0">
                            <img src={rejected_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            case 4:
                return (
                    <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                        <div data-src={dialed_call} className="border rounded px-1 py-0">
                            <img src={dialed_call} alt="call" className="cursor-pointer w-35px h-35px" />
                        </div>
                    </LightGallery>
                );
            default:
                return null;
        }
    };

    const renderCallStatusbadge = (status) => {
        switch (status) {
            case 0:
                return (
                    <div className="badge text-black rounded fw-bold fs-8" style={{ backgroundColor: '#ffbc67' }}>Outgoing Call</div>
                );
            case 1:
                return (
                    <div className="badge cess text-black rounded fw-bold fs-8" style={{ backgroundColor: '#ebb5a9' }}>Incoming Call</div>
                );
            case 2:
                return (
                    <div className="badge text-white rounded fw-bold fs-8" style={{ backgroundColor: '#4c84e1' }}>Missed Call</div>
                );
            case 3:
                return (
                    <div className="badge text-white rounded fw-bold fs-8" style={{ backgroundColor: '#ff0028' }}>Rejected Call</div>
                );
            case 4:
                return (
                    <div className="badge text-black rounded fw-bold fs-8" style={{ backgroundColor: '#6ac7e8 ' }}>Dailed Call</div>
                );
            default:
                return null;
        }
    };

    const monthShort = yeardisplay.toLocaleString('en-US', { month: 'short' }); // e.g. "Apr"

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    const [mobile_no, setMobileno] = useState('');
    const [lead_name, setname] = useState('');

    const [latitude, setlatitude] = useState('');
    const [longitude, setlongitude] = useState('');

    const handleModalToggle = (num, name) => {
        setMobileno(num);
        setname(name);
        setModalType("Add");
        setOpen(true);
    };

    const handleModalLocation = (lat, long) => {
        setlatitude(lat);
        setlongitude(long);
        setModalType("Location");
        setOpen(true);
    };

    const [isMaintenance, setIsMaintenance] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "managecalls"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);


    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Calls </strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }

    return (
        <>
            {loading ? (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}><Skeleton width={150} /></h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Skeleton width={70} /></li>
                            <li className="breadcrumb-item"><Skeleton width={20} /></li>
                            <li className="breadcrumb-item active"><Skeleton width={100} /></li>
                        </ol>
                    </div>
                    <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                        <Skeleton width={200} height={30} />
                    </div>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                    <div className='mb-0'>
                        <div className="mb-0 px-0">
                            <h4 className='breadcrumb-header'>Manage Calls</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Lead Management</li>
                        </ol>
                    </div>

                    {permissions.calls_list === 1 && (
                        <div className="d-flex align-items-center justify-content-end mb-1">
                            <div className="w-60 mb-1 col-lg-8">
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker format="MMM-YYYY" value={yeardisplay} calendarPosition="top" mode="single" onlyMonthPicker={true} minDate={new Date(1900, 0, 1)} maxDate={new Date()} onChange={(date) => setyeardisp(new Date(date))} />
                                    <div className='input-group-text bg-transparent border-0 px-0 py-0' style={{ padding: 0, margin: 0, display: 'flex', alignItems: 'center' }}><i class="fa-solid fa-caret-down fs-4"></i></div>
                                </div>
                            </div>
                        </div>
                    )}

                    {open && modalType === "Add" && (
                        <Add show={open} onClose={() => setOpen(false)} num={mobile_no} name={lead_name} refresh={fetchData} />
                    )}
                    {open && modalType === "Location" && (
                        <Location show={open} onClose={() => setOpen(false)} lat={latitude} long={longitude} />
                    )}
                </div>
            )}

            {permissions.calls_list === 1 && (
                <Row className='mb-4'>

                    {loading ? (
                        <div className="d-flex align-items-center justify-content-lg-between justify-content-center flex-wrap gap-2">
                            <div className="d-flex align-items-center justify-content-center flex-wrap gap-2 mb-0">
                                {[1, 2, 3, 4, 5].map((_, index) => (
                                    <div
                                        key={index}
                                        className="text-center border border-2 p-2 mb-2"
                                        style={{ width: 140, minHeight: 150 }}
                                    >
                                        {/* Title */}
                                        <div className="fw-semibold fs-6 text-center mb-1">
                                            <Skeleton width={100} height={14} />
                                        </div>

                                        {/* Month text */}
                                        <div className="fw-semibold fs-7 text-center mb-2">
                                            <Skeleton width={70} height={12} />
                                        </div>

                                        {/* Icon placeholder */}
                                        <div className="d-flex justify-content-center mb-2">
                                            <Skeleton circle width={45} height={45} />
                                        </div>

                                        {/* Badge(s) placeholder */}
                                        <div className="d-flex justify-content-center align-items-center gap-1 mt-2">
                                            <Skeleton width={40} height={18} borderRadius={10} />
                                            {/* For cards that have two badges (like Outgoing / Missed) */}
                                            {index === 1 || index === 3 ? (
                                                <>
                                                    <Skeleton width={8} height={14} /> {/* For “/” separator */}
                                                    <Skeleton width={40} height={18} borderRadius={10} />
                                                </>
                                            ) : null}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="d-flex align-items-center justify-content-lg-between justify-content-center flex-wrap gap-2">
                            <div className="d-flex align-items-center justify-content-center flex-wrap gap-2 mb-0">
                                <div className="text-center border border-2 p-2 mb-2" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Total Incoming Calls">
                                    <div className="fw-semibold fs-6 text-black text-center">Incoming Calls</div>
                                    <div className="fw-semibold fs-7 text-black text-center">(<span className="text-primary"> {monthShort} </span>)</div>
                                    <div>
                                        <img src={imcoming_call} className='w-45px h-45px' alt="Incomming Call" />
                                    </div>
                                    <div className="d-block mt-2">
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Incomming Calls</span> </Tooltip>}>
                                            <div className="badge text-black rounded fw-bold fs-8" style={{ backgroundColor: '#ebb5a9' }}>{incommingCalls}</div>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                                <div className="text-center border border-2 p-2 mb-2">
                                    <div className="fw-semibold fs-6 text-black text-center">Outgoing Calls</div>
                                    <div className="fw-semibold fs-7 text-black text-center">(<span className="text-primary"> {monthShort} </span>)</div>
                                    <div>
                                        <img src={outgoing_call} className='w-45px h-45px' alt="Incomming Call" />
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center mt-2">
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Outgoing Calls</span> </Tooltip>}>
                                            <label className='badge text-black rounded fw-bold fs-8' style={{ backgroundColor: '#ffbc67' }}>{Outgoingcalls}</label>
                                        </OverlayTrigger>
                                        <label className="text-black fs-6 fw-bold ms-1 me-1">/</label>
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Outgoing Call Rate</span> </Tooltip>}>
                                            <label className='badge text-black rounded fw-bold fs-8' style={{ backgroundColor: '#ffbc67' }}>{outgoingCallRate}</label>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                                <div className="text-center border border-2 p-2 mb-2" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Dialed Calls">
                                    <div className="fw-semibold fs-6 text-black text-center">Dialed Calls</div>
                                    <div className="fw-semibold fs-7 text-black text-center">(<span className="text-primary"> {monthShort} </span>)</div>
                                    <div>
                                        <img src={dialed_call} className='w-45px h-45px' alt="Incomming Call" />
                                    </div>
                                    <div className="d-block mt-2">
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Dialed Calls</span> </Tooltip>}>
                                            <div className="badge text-black rounded fw-bold fs-8" style={{ backgroundColor: '#6ac7e8 ' }}>{DailedCalls}</div>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                                <div className="text-center border border-2 p-2 mb-2">
                                    <div className="fw-semibold fs-6 text-black text-center">Missed Calls</div>
                                    <div className="fw-semibold fs-7 text-black text-center">(<span className="text-primary"> {monthShort} </span>)</div>
                                    <div>
                                        <img src={missed_call} className='w-45px h-45px' alt="Incomming Call" />
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center mt-2">
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Missed Calls</span> </Tooltip>}>
                                            <div className="badge text-white rounded fw-bold fs-8" style={{ backgroundColor: '#4c84e1' }}>{missedCalls}</div>
                                        </OverlayTrigger>
                                        <label className="text-black fs-6 fw-bold ms-1 me-1">/</label>
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Missed Call Ratio</span> </Tooltip>}>
                                            <div className="badge text-white rounded fw-bold fs-8" style={{ backgroundColor: '#4c84e1' }}>{missedCallRate}</div>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                                <div className="text-center border border-2 p-2 mb-2" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-original-title="Total Rejected Calls">
                                    <div className="fw-semibold fs-6 text-black text-center">Rejected Calls</div>
                                    <div className="fw-semibold fs-7 text-black text-center">(<span className="text-primary"> {monthShort} </span>)</div>
                                    <div>
                                        <img src={rejected_call} className='w-45px h-45px' alt="Incomming Call" />
                                    </div>
                                    <div className="d-block mt-2">
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Rejected Calls</span> </Tooltip>}>
                                            <div className="badge text-white rounded fw-bold fs-8" style={{ backgroundColor: '#ff0028' }}>{rejectedCalls}</div>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <Col xl={12} className='mb-3'>
                        <div className="custom-tab-1">
                            <Row>
                                <Col xl={12}>

                                    {loading ? (
                                        <div className="table-container">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="d-flex align-items-center">
                                                    <Skeleton width={40} height={12} className="me-2" />
                                                    <Skeleton width={60} height={28} borderRadius={4} />
                                                </div>

                                                <Skeleton width={180} height={36} borderRadius={4} />
                                            </div>

                                            <table
                                                className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"
                                                style={{ borderBottom: "2px solid #ddd" }}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th><Skeleton width={100} height={16} /></th>
                                                        <th><Skeleton width={100} height={16} /></th>
                                                        <th><Skeleton width={100} height={16} /></th>
                                                        <th><Skeleton width={100} height={16} /></th>
                                                        <th><Skeleton width={100} height={16} /></th>
                                                        <th><Skeleton width={100} height={16} /></th>
                                                        <th><Skeleton width={100} height={16} /></th>
                                                        <th><Skeleton width={100} height={16} /></th>
                                                        <th><Skeleton width={100} height={16} /></th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {[...Array(perPage)].map((_, index) => (
                                                        <tr key={index}>
                                                            {/* Staff */}
                                                            <td>
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <Skeleton circle width={20} height={20} />
                                                                    <div>
                                                                        <Skeleton width={80} height={12} className="mb-1" />
                                                                        <Skeleton width={60} height={10} />
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            {/* Communicator */}
                                                            <td>
                                                                <Skeleton width={100} height={12} className="mb-1" />
                                                                <Skeleton width={80} height={10} />
                                                            </td>

                                                            {/* Lead Status */}
                                                            <td className="text-center">
                                                                <Skeleton width={50} height={18} />
                                                            </td>

                                                            {/* Call Date */}
                                                            <td>
                                                                <Skeleton width={80} height={12} />
                                                            </td>

                                                            {/* Start Time */}
                                                            <td>
                                                                <Skeleton width={50} height={12} />
                                                            </td>

                                                            {/* End Time */}
                                                            <td>
                                                                <Skeleton width={50} height={12} />
                                                            </td>

                                                            {/* Duration */}
                                                            <td>
                                                                <Skeleton width={40} height={12} />
                                                            </td>

                                                            {/* Status */}
                                                            <td className="text-center">
                                                                <Skeleton width={50} height={18} />
                                                            </td>

                                                            {/* Location */}
                                                            <td className="text-center">
                                                                <Skeleton circle width={20} height={20} />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <Skeleton width={200} height={12} />

                                                <div className="d-flex align-items-center gap-2">
                                                    {[1, 2, 3, 4].map((_, index) => (
                                                        <Skeleton
                                                            key={index}
                                                            width={40}
                                                            height={26}
                                                            borderRadius={4}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="table-container">

                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                {/* Left: Show entries dropdown */}
                                                <div>
                                                    <label className="me-2">Show</label>
                                                    <select
                                                        className="form-select d-inline w-auto"
                                                        style={{ fontSize: '0.85rem', height: '30px' }}
                                                        value={perPage}
                                                        onChange={(e) => {
                                                            setPerPage(Number(e.target.value));
                                                            setPage(1); // Reset to first page
                                                        }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={25}>25</option>
                                                        <option value={50}>50</option>
                                                        <option value={100}>100</option>
                                                    </select>
                                                </div>

                                                {/* Right: Search input */}
                                                <div>
                                                    <input
                                                        type="text"
                                                        style={{ fontSize: '0.85rem', height: '40px' }}
                                                        placeholder="Search..."
                                                        className="form-control"
                                                        value={searchTerm}
                                                        onChange={(e) => {
                                                            setSearchTerm(e.target.value);
                                                            setPage(1); // Reset page on new search
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <table style={{ borderBottom: '2px solid #ddd' }} className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                                <thead>
                                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                                                        <th className='min-w-90px'>Staff</th>
                                                        <th className='min-w-100px'>Communicator</th>
                                                        <th className='min-w-40px text-center'>Lead Status</th>
                                                        <th className='min-w-100px'>Call Date</th>
                                                        <th className='min-w-50px'>Start Time</th>
                                                        <th className='min-w-50px'>End Time</th>
                                                        <th className='min-w-50px'>Duration</th>
                                                        <th className='min-w-50px text-center'>Status</th>
                                                        <th className='min-w-20px text-center'>Location</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7 align-top">
                                                    {datas.length === 0 && hasFetched ? (
                                                        <tr>
                                                            <td colSpan="9" className="text-center text-muted py-2">
                                                                No data available
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        <>
                                                            {datas.map((data, index) => (
                                                                <tr key={data.sno}>
                                                                    <td>
                                                                        <div className="d-flex align-items-center justify-content-start gap-2">
                                                                            {renderCallStatusContent(data.call_status)}
                                                                            <div className='mb-0'>
                                                                                <label className='text-black font-w400 fs-7'>{data.staff_name}</label>
                                                                                <div className="d-block">
                                                                                    <div className="fs-8 font-w600 text-dark">{data.staff_phone_no}</div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.customer_name}</div>
                                                                        <div className="d-block position-relative" style={{ maxWidth: '75%' }}>
                                                                            <div className="d-flex align-items-center">
                                                                                <div className='text-dark font-w600 fs-8 text-wrap mw-75'>{data.customer_phone_no}</div>
                                                                                {data.is_lead === 0 && permissions.calls_add_lead === 1 && (
                                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"><span className="fs-8 text-white fw-semibold">Add Lead</span></Tooltip>}>
                                                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => {
                                                                                            // Remove +91 if it exists at the start
                                                                                            const normalizedNumber = data.customer_phone_no.startsWith('+91')
                                                                                                ? data.customer_phone_no.slice(3)
                                                                                                : data.customer_phone_no;
                                                                                            handleModalToggle(normalizedNumber, data.customer_name);
                                                                                        }}>
                                                                                            <span>
                                                                                                <i class="fa-solid fa-user-plus fs-4 mt-1"></i>
                                                                                            </span>
                                                                                        </Button>
                                                                                    </OverlayTrigger>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td className='text-center'>
                                                                        {data.is_lead === 1 ? (
                                                                            <Badge bg="none" className='py-1 px-2 fs-8' style={{ background: data.background_color, color: data.text_color }}>{data.leadstatus_name}</Badge>
                                                                        ) : (
                                                                            <div className="text-black rounded fw-bold fs-8">-</div>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <div className='text-black font-w400 fs-7  mw-75'>{formatDate(data.call_start_date)}</div>
                                                                    </td>
                                                                    <td>
                                                                        <div className='text-black font-w400 fs-7  mw-75'>{convert24to12(data.call_start_time)}</div>
                                                                    </td>
                                                                    <td>
                                                                        <div className='text-black font-w400 fs-7  mw-75'>{convert24to12(data.call_end_time)}</div>
                                                                    </td>
                                                                    <td>
                                                                        <div className='text-black font-w400 fs-7 mw-75'>{data.call_duration}</div>
                                                                    </td>
                                                                    <td className='text-center'>
                                                                        {renderCallStatusbadge(data.call_status)}
                                                                    </td>
                                                                    <td>
                                                                        <div className="text-center">
                                                                            {permissions.calls_location === 1 && (
                                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={
                                                                                    <Tooltip className="toltip-popover">
                                                                                        <span className="fs-8 text-white fw-semibold">Location</span>
                                                                                    </Tooltip>
                                                                                }>
                                                                                    <Button onClick={() => handleModalLocation(data.latitude, data.longitude)} variant="primary tp-btn-light px-2 py-1 me-1" >
                                                                                        <span>
                                                                                            <i class="fa-solid fa-map-location-dot fs-4 mt-1"></i>
                                                                                            {/* <i class="fa-solid fa-location-dot fs-4 mt-1"></i> */}
                                                                                        </span>
                                                                                    </Button>
                                                                                </OverlayTrigger>
                                                                            )}
                                                                        </div>

                                                                        {permissions.calls_location != 1 && (
                                                                            <div className="text-center">
                                                                                No Actions
                                                                            </div>
                                                                        )}

                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                    )}
                                                </tbody>
                                            </table>

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                {/* Bottom left: Showing x to y of z entries */}
                                                <div>
                                                    {datas.length > 0 ? (
                                                        <span className="text-muted">
                                                            Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                                        </span>
                                                    ) : (
                                                        <span className="text-muted">
                                                            Showing 0 to 0 of 0 entries
                                                        </span>
                                                    )}
                                                </div>

                                                {/* Bottom right: Pagination */}
                                                {/* <nav>
                                                <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                                    </li>
                                                    {[...Array(totalPages)].map((_, i) => (
                                                    <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                                    </li>
                                                    ))}
                                                    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                                    </li>
                                                </ul>
                                            </nav> */}

                                                <nav>
                                                    <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                                        {/* Previous Button */}
                                                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                                Previous
                                                            </button>
                                                        </li>

                                                        {/* First Page */}
                                                        <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                                1
                                                            </button>
                                                        </li>

                                                        {/* Left Ellipsis */}
                                                        {page > 4 && (
                                                            <li className="page-item disabled">
                                                                <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                            </li>
                                                        )}

                                                        {/* Pages Around Current */}
                                                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                            .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                            .map(p => (
                                                                <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                                        {p}
                                                                    </button>
                                                                </li>
                                                            ))}

                                                        {/* Right Ellipsis */}
                                                        {page < totalPages - 3 && (
                                                            <li className="page-item disabled">
                                                                <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                            </li>
                                                        )}

                                                        {/* Last Page */}
                                                        {totalPages > 1 && (
                                                            <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                                    {totalPages}
                                                                </button>
                                                            </li>
                                                        )}

                                                        {/* Next Button */}
                                                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                                Next
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </nav>


                                            </div>

                                        </div>
                                    )}

                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            )}

            {permissions.calls_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}
        </>
    )


}
export default Manage_Calls;